'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_model$package$MeasuringUnitId$() {
  $n_Lmealorama_model$package$MeasuringUnitId$ = this;
  $m_Lmealorama_model$package$MeasuringUnitId$();
}
export { $c_Lmealorama_model$package$MeasuringUnitId$ as $c_Lmealorama_model$package$MeasuringUnitId$ };
$p = $c_Lmealorama_model$package$MeasuringUnitId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_model$package$MeasuringUnitId$;
/** @constructor */
function $h_Lmealorama_model$package$MeasuringUnitId$() {
}
export { $h_Lmealorama_model$package$MeasuringUnitId$ as $h_Lmealorama_model$package$MeasuringUnitId$ };
$h_Lmealorama_model$package$MeasuringUnitId$.prototype = $p;
var $d_Lmealorama_model$package$MeasuringUnitId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_model$package$MeasuringUnitId$, "mealorama.model$package$MeasuringUnitId$", ({
  KS: 1
}));
export { $d_Lmealorama_model$package$MeasuringUnitId$ as $d_Lmealorama_model$package$MeasuringUnitId$ };
var $n_Lmealorama_model$package$MeasuringUnitId$;
function $m_Lmealorama_model$package$MeasuringUnitId$() {
  if ((!$n_Lmealorama_model$package$MeasuringUnitId$)) {
    $n_Lmealorama_model$package$MeasuringUnitId$ = new $c_Lmealorama_model$package$MeasuringUnitId$();
  }
  return $n_Lmealorama_model$package$MeasuringUnitId$;
}
export { $m_Lmealorama_model$package$MeasuringUnitId$ as $m_Lmealorama_model$package$MeasuringUnitId$ };
//# sourceMappingURL=mealorama.model$package$-Measuring-Unit-Id$.js.map
